import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './ui/button';

const ContactCTA = () => {
  const { language } = useLanguage();

  return (
    <section className="bg-gradient-to-r from-primary to-secondary py-20 text-white" data-testid="cta-section">
      <div className="container mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl font-bold mb-6">
            {language === 'tc' ? '準備好合作了嗎？' : language === 'cn' ? '准备好合作了吗？' : 'Ready to Partner With Us?'}
          </h2>
          <p className="text-xl mb-8 opacity-90">
            {language === 'tc'
              ? '聯絡我們，了解更多專業海產服務'
              : language === 'cn'
              ? '联络我们，了解更多专业海产服务'
              : 'Contact us to learn more about our professional seafood services'}
          </p>
          <Link to="/contact">
            <Button 
              className="rounded-full px-10 py-6 text-lg bg-white text-primary hover:bg-slate-50"
              data-testid="contact-us-btn"
            >
              {language === 'tc' ? '聯絡我們' : language === 'cn' ? '联络我们' : 'Contact Us'}
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactCTA;
